// extracted by mini-css-extract-plugin
export default {"modal":"nvITQ","loader":"nhRFE","icon":"Hj5pt","spin":"cmHC4","text":"MvwMf","background":"T0v2A"};